module.exports = __webpack_public_path__ + "img/trunk_fg_deco.bf219c76.png";